module.exports = __webpack_public_path__ + "img/product12.7dc8469a.png";